/*eslint-disable*/
import React, { useState } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import styles from "assets/jss/material-kit-react/components/footerStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { ffLogoSort, nfLogoSort } from "components/Logos";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const [mail, setMail] = useState("");

  const classes = useStyles();
  const { whiteFont } = props;
  const { english } = props;

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <GridContainer direction="row" justify="flex-end" alignItems="center">
          <GridItem xs={12} md={4} className={classes.flexLeft}>
            {english ? "Contact us: " : "Kontakt oss: "}
            <a
              className={classes.a}
              href={mail}
              onClick={() =>
                setMail("mailto:oljefondkampanjen@fagforbundet.no")
              }
            >
              oljefondkampanjen@fagforbundet.no
            </a>
          </GridItem>
          <GridItem xs={12} md={2}>
            {" "}
          </GridItem>
          <GridItem xs={12} md={3}>
            {english ? "Visit our websites: " : "Besøk våre hjemmesider: "}
          </GridItem>
          <GridItem xs={12} md={3}>
            <div className={classes.flexInline}>
              <a
                href="https://www.fagforbundet.no/"
                className={classes.a}
                aria-label="Fagforbundets hjemmeside"
              >
                {ffLogoSort}
              </a>
              <a
                href="https://www.folkehjelp.no/"
                className={classes.a}
                aria-label="Norsk folkehjelps hjemmeside"
              >
                {nfLogoSort}
              </a>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool,
};
